import React from 'react';
import { Form } from '@blueprintnyc/bpnyc-common';
import Editor from '@/components/Editor';
import WidgetOptionsForm from './WidgetOptionsForm';
import WidgetOptionGroupPermissions from './WidgetOptionGroupPermissions';

const TextWidgetOptions = props => {
	const {
		widgetToUpdate,
		handleChange,
		theme,
		preview,
		event,
		handleGroupChange,
		targetKeys,
	} = props;

	return (
		<WidgetOptionsForm initialValues={widgetToUpdate.props} handleChange={handleChange}>
			<Form.Item label="Text Editor" name="text">
				<Editor theme={theme} widgetToUpdate={widgetToUpdate} preview={preview} />
			</Form.Item>
			<WidgetOptionGroupPermissions
				event={event}
				handleGroupChange={handleGroupChange}
				targetKeys={targetKeys}
			/>
		</WidgetOptionsForm>
	);
};

export default TextWidgetOptions;
